module.exports = __webpack_public_path__ + "media/images/zebra-right-58137eba9eba4830b0114529219c79ee.png";